const ENABLED_KEY = 'voiceControlEnabled'
const HELP_SEEN_KEY = 'voiceControlHelpSeen'

function storage(): Storage | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null
  } catch {
    return null
  }
}

export function getStoredVoiceEnabled(): boolean {
  return storage()?.getItem(ENABLED_KEY) === '1'
}

export function setStoredVoiceEnabled(value: boolean): void {
  try {
    storage()?.setItem(ENABLED_KEY, value ? '1' : '0')
  } catch {
    return
  }
}

export function hasSeenVoiceHelp(): boolean {
  return storage()?.getItem(HELP_SEEN_KEY) === '1'
}

export function markVoiceHelpSeen(): void {
  try {
    storage()?.setItem(HELP_SEEN_KEY, '1')
  } catch {
    return
  }
}
